/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { CarrierService } from "./CarrierService";
import {
  CarrierServiceFromJSON,
  CarrierServiceFromJSONTyped,
  CarrierServiceToJSON,
  CarrierServiceToJSONTyped,
} from "./CarrierService";

/**
 *
 * @export
 * @interface ExperimentRun
 */
export interface ExperimentRun {
  /**
   *
   * @type {string}
   * @memberof ExperimentRun
   */
  experimentRunId?: string;
  /**
   *
   * @type {string}
   * @memberof ExperimentRun
   */
  experimentId?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof ExperimentRun
   */
  startedAt?: OffsetDateTime;
  /**
   *
   * @type {string}
   * @memberof ExperimentRun
   */
  startedBy?: string;
  /**
   *
   * @type {string}
   * @memberof ExperimentRun
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ExperimentRun
   */
  purpose?: string;
  /**
   *
   * @type {string}
   * @memberof ExperimentRun
   */
  notes?: string;
  /**
   *
   * @type {Array<CarrierService>}
   * @memberof ExperimentRun
   */
  selectedCarriers?: Array<CarrierService>;
}

/**
 * Check if a given object implements the ExperimentRun interface.
 */
export function instanceOfExperimentRun(value: object): value is ExperimentRun {
  return true;
}

export function ExperimentRunFromJSON(json: any): ExperimentRun {
  return ExperimentRunFromJSONTyped(json, false);
}

export function ExperimentRunFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ExperimentRun {
  if (json == null) {
    return json;
  }
  return {
    experimentRunId:
      json["experimentRunId"] == null ? undefined : json["experimentRunId"],
    experimentId:
      json["experimentId"] == null ? undefined : json["experimentId"],
    startedAt: json["startedAt"] == null ? undefined : json["startedAt"],
    startedBy: json["startedBy"] == null ? undefined : json["startedBy"],
    name: json["name"] == null ? undefined : json["name"],
    purpose: json["purpose"] == null ? undefined : json["purpose"],
    notes: json["notes"] == null ? undefined : json["notes"],
    selectedCarriers:
      json["selectedCarriers"] == null
        ? undefined
        : (json["selectedCarriers"] as Array<any>).map(CarrierServiceFromJSON),
  };
}

export function ExperimentRunToJSON(json: any): ExperimentRun {
  return ExperimentRunToJSONTyped(json, false);
}

export function ExperimentRunToJSONTyped(
  value?: ExperimentRun | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    experimentRunId: value["experimentRunId"],
    experimentId: value["experimentId"],
    startedAt: value["startedAt"],
    startedBy: value["startedBy"],
    name: value["name"],
    purpose: value["purpose"],
    notes: value["notes"],
    selectedCarriers:
      value["selectedCarriers"] == null
        ? undefined
        : (value["selectedCarriers"] as Array<any>).map(CarrierServiceToJSON),
  };
}
